import { schema } from "normalizr";
import { PROFILE_SCHEMA } from "./index";
import companySchema from "./companySchema";

export default new schema.Entity(
  PROFILE_SCHEMA,
  {
    company: companySchema,
  },
  {
    processStrategy: (entity) => ({
      ...entity,
      rankingParticipant: entity.role === "STUDENT" ? (entity.rankingParticipant ? "S" : "N") : null,
    }),
  }
);
